import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { callFunctionConditionallyWithWarningCurry } from '../../utils/utils';
import styles from './LineDropdownSelector.module.css';
import Select from 'react-select';
import { JLR_PLANT } from '../../constants';

const DropScreenLineDropdownSelector = ({
  hasActiveEdits,
  isDarkStyle,
  height = 30,
}) => {
  const [line, setLine] = usePlantAndLinesStore().lineState;
  const [lineOptions] = usePlantAndLinesStore().lineOptions;
  const [plant] = usePlantAndLinesStore().plantState;

  const handleLineChange = valueObject => {
    setLine(valueObject);
  };

  const customStyles = {
    control: provided => ({
      ...provided,
      width: 70,
      minWidth: 70,
      height: height,
      minHeight: height,
      fontSize: '12px',
      background: plant.label === JLR_PLANT ? '#FFFFFF' : 'none',
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      width: 70,
      minWidth: 70,
      height: 30,
      minHeight: 30,
      fontSize: '12px',
    }),
    dropdownIndicator: provided => ({
      ...provided,
      width: 30,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    singleValue: provided => ({
      ...provided,
      color: plant.label === JLR_PLANT ? '#707070' : '#0275a7',
      fontWeight: 'bold',
    }),
  };

  return (
    <Select
      value={line}
      styles={customStyles}
      className={clsx(styles.dropdown, isDarkStyle && styles.dropdownDark)}
      classNamePrefix="select-line"
      onChange={callFunctionConditionallyWithWarningCurry(
        handleLineChange,
        hasActiveEdits,
      )}
      options={lineOptions}
    />
  );
};

DropScreenLineDropdownSelector.prototypes = {
  hasActiveEdits: PropTypes.bool,
  isDarkStyle: PropTypes.bool,
  height: PropTypes.number,
};
export default DropScreenLineDropdownSelector;
